// @flow
import SMSBundles from './SMSBundles';

export default SMSBundles;
